import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Content = styled.div`
  position: relative;

  .chakra-table__container {
    overflow: visible !important; /* Allow dropdowns to overflow */
    position: relative;

    /* Force dropdowns to render above everything */
    .chakra-menu__menu,
    .chakra-menu__menu-list {
      z-index: 99999 !important;
      position: fixed !important;
      overflow: visible !important;
    }
  }
`;

export const Centered = styled.div`
  display: flex;
  align-items: center;
`;

export const TableLink = styled(Link)`
  color: #054ad9;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const CustomUserInitials = styled.div<{
  size: number;
  pictureUrl: string;
  firstName: string;
  lastName: string;
}>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background: ${(props) =>
    props.pictureUrl ? `url(${props.pictureUrl}) center/cover` : '#e2e8f0'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  margin-right: 12px;

  &::before {
    content: '${(props) => props.firstName.charAt(0)}${(props) => props.lastName.charAt(0)}';
  }
`;

export const NotFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  height: 410px;
  color: #718096;
  text-align: center;

  p {
    margin-bottom: 24px;
  }
`;

export const NotFoundSubtitle = styled.p`
  font-size: 26px;
  line-height: 30px;
  font-weight: 600;
  color: #2d3748;
`;

export const StatusFilterContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 10px 0 20px 0;
`;

export const StatusFilterButton = styled.button<{ isActive: boolean }>`
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid ${(props) => (props.isActive ? '#054ad9' : '#e2e8f0')};
  background-color: ${(props) => (props.isActive ? '#054ad9' : '#ffffff')};
  color: ${(props) => (props.isActive ? '#ffffff' : '#4a5568')};
  min-width: 80px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) => (props.isActive ? '#0439b3' : '#f7fafc')};
    border-color: ${(props) => (props.isActive ? '#0439b3' : '#cbd5e0')};
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(5, 74, 217, 0.1);
  }
`;
